import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchFilter from './SearchFilter';
import {
  fetchSecurityBreakdown,
  selectSecurityBreakdown,
  selectSecurityLoading,
  selectSecurityError,
} from '../../../store/engagementAnalyticsSlice';

const thClass =
  'h-11 px-6 py-4 text-base font-medium text-[#757575] text-center align-middle bg-[#F7F7F7] whitespace-nowrap';
const tdClass =
  'h-16 px-6 py-4 text-base text-[#1D2739] text-center align-middle border-b border-[#EEE] bg-white [tr:last-child_&]:border-b-0';

export default function AdminSecurity() {
  const dispatch = useDispatch();
  const [viewBy, setViewBy] = useState('Department');
  const isTenant = viewBy === 'Tenants';
  const viewByParam = isTenant ? 'tenant' : 'department';

  const rows = useSelector(selectSecurityBreakdown);
  const loading = useSelector(selectSecurityLoading);
  const error = useSelector(selectSecurityError);

  useEffect(() => {
    dispatch(fetchSecurityBreakdown({ activeFilter: 'This Month', viewBy: viewByParam }));
  }, [dispatch, viewByParam]);

  return (
    <div className="p-6 space-y-8">
      <h1 className="text-2xl font-medium text-[#1D2739] text-left">Security</h1>
      <SearchFilter showFilterButton={false} showViewBy onViewByChange={setViewBy} />

      {error && (
        <div className="rounded-lg border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-600">
          {error}
        </div>
      )}

      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full">
          <thead>
            <tr>
              {isTenant && <th className={thClass}>Tenant</th>}
              <th className={thClass}>Department</th>
              <th className={thClass}> Failed login attempts</th>
              <th className={thClass}>Privileged actions</th>
              <th className={thClass}>Export attempts</th>
              <th className={thClass}>Last security event timestamp</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={isTenant ? 6 : 5} className={`${tdClass} py-8 text-[#7E7E7E]`}>
                  Loading…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={isTenant ? 6 : 5} className={`${tdClass} py-8 text-[#7E7E7E]`}>
                  No security events recorded for this period
                </td>
              </tr>
            ) : (
              rows.map((row, i) => (
                <tr key={i} className="border-b last:border-b-0 hover:bg-gray-50">
                  {isTenant && <td className={tdClass}>{row.tenant}</td>}
                  <td className={tdClass}>{row.department}</td>
                  <td className={tdClass}>{row.failedLoginAttempts}</td>
                  <td className={tdClass}>{row.privilegedActions}</td>
                  <td className={tdClass}>{row.exportAttempts}</td>
                  <td className={tdClass}>{row.lastSecurityEventTimestamp}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
